import {
  CircularProgress,
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  useMediaQuery,
} from "@mui/material";
import Unit from "components/Unit/Unit.model";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CustomInput, CustomLabel } from "./styled-components";
import SuccessMessage from "./SuccessMessage";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { _project } from "state/store.projects";
import { useLocation } from "react-router-dom";
import { useFetch } from "hooks/fetch/useFetch";
import { EMAIL, GETLEADTOKEN, LEAD_ACCEPTED_STATUS, LEAD_PHONE_REJECTED_STATUS, POST_TESTLEAD } from "api/api";
import { motion } from "framer-motion";
import axios from "axios";
import { PhoneNumberDropdown } from "components/AdvanceDropdown/PhoneNumberDropdown/Dropdown";
import { CheckBox } from "components/FormComponent/CheckBox";
import { CustomButton } from "components/Unit/NewReservationButton";
import { useBreak } from "hooks/useBreak";
import { axios_live } from "utilities/axios.instances";
import { _bootstrap } from "state/store.bootstrap";
import { EmailField, TextField } from "components/MainFooter/FormField";


const ContactForm = ({ drawerType, grid, unit, campaignId, children }) => {
  const isFullEidoSite          = ['frontpage', 'unitpage', 'propertypage']
  const sm                      = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { i18n: { language }, } = useTranslation();

  const [personName, setPersonName]     = useState([]);
  const [nationName, setNationName]     = useState([]);
  const [submitted, setSubmitted]       = useState(false);
  const [errorMsg, setErrorMsg]         = useState("");
  const [describeName, setDescribeName] = useState([]);

    // const { submit, successMsg, errorMsg, inProgress, submitted } = useHubspot();
  const { register, handleSubmit, control, reset, watch, formState: { errors, isValid, isSubmitting } } = useForm({ mode: 'onChange',
     defaultValues: {
      country_id: {
          "country_id": 47,
          "name_dk": "Danmark",
          "name_eng": "Denmark",
          "country_code": "+45",
          "iso_code": "DK",
          "value": `+45 ${language === "da" ? 'Danmark' : 'Denmark' }`,
          "label": `+45 ${language === "da" ? 'Danmark' : 'Denmark' }`
        }
     }
   });
  const here                                                                              = useLocation().pathname;
  const atUnit                                                                            = here.includes("unit");
  const { pin, pid }                                                                      = useGet(active_project)
  const isMobile                                                                          = useBreak('md_dn')
  const unitPid                                                                           = unit.getValue("ProjectID")
  const sitename                                                                          = useGet(_bootstrap).sitename;
 
  const testLeadData = useFetch({ url: GETLEADTOKEN(campaignId) });

  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const isDesktop = useMediaQuery('(min-width:1200px)');

  const unitNo      = unit?.getValue("Projeknr") ? `${buttonsLabel?.filter( btn => btn?.UILabelProperty === 'Bolignr')[0]?.Label} ${unit.getValue("Projeknr")},` : "";
  const unitAddress = unit?.getAddress() ?? "";
  const unitId      = unit?.getId();
  const aptNo       = unit?.getValue("Lejlighedsnr")

  const isRent  = unit?.isRent()
  const homeUrl = window.location.origin;
  const unitUrl = unit?.getUrl(`${homeUrl}/${language}`) ?? "";
  
  
  const [checked, setChecked]   = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);

  const handleCheckbox = (event) => { setChecked(event.target.checked); };
    // const handleCheckbox2 = (event) => { setChecked2(event.target.checked); };


  useEffect(()=> {
      testLeadData.mutate()
  }, [language])

  useEffect(() => {
    if (submitted) {
      reset();
      setChecked(false);
      setChecked2(false)
    }
  }, [submitted]);


  useEffect(() => {
    const subscription = watch(() => setErrorMsg(""));
    return () => subscription.unsubscribe();
  }, [watch]);

  const handleFormSubmit = async (data) => {
    const saleType = {
      "da": {
        "rent" : "Udlejning",
        "sales": "Salg"
      },
      "en": {
        "rent" : "Rent",
        "sales": "Sales"
      }
    }
  const source = window.location.href;
  const media  = isFullEidoSite.some((fe) => here.includes(fe));
  const isFES  = media ? "Ei.DO website" : "Ei.DO boligvælger";
  const utms   = {
    utm_source  : "google",
    utm_medium  : "cpc",
    utm_campaign: "spring_sale",
    utm_content : "ad_variation_1"
  }

  let utmParam = {};
  for (let [key, value] of new URLSearchParams(location.search).entries()) {
    if(key === "utm_source" || key === "utm_medium" || key === "utm_campaign" || key === "utm_content") {
      utmParam[key] = value;
    }
  }

   const leadCountry_code = data?.country_id?.country_id

        const payload = new URLSearchParams({
          B_ID        : unitId,
          token       : testLeadData?.D?.token,
          hash        : testLeadData?.D?.hash,
          CAMPAIGN    : campaignId,
          Fornavne    : data.firstname,
          Efternavn   : data.lastname,
          Email_privat: data.email,
          media       : isFES,
          source,
            country_code: leadCountry_code,
            // nationality_code: leadNationality,
            // SELECTIONS: `${DescribeIDMapping?.[data?.describe_id.value] || "0"},${data?.viewing_id ? `${data.viewing_id}` : "0"},${city_status_id?.[data?.civil_status?.value] || "0"},${whereHearProperty_id?.[data?.whereHearProperty_status?.value] || "0"}`,
            Telefon_mobil: data.phone,
          Comments   : data.kommentar?.length ? data.kommentar: "",
          ANSWER_JSON: [],
          ...utmParam
        });

      const failureMessage =
        language === "da"
          ? "Noget gik galt. Prøv igen"
          : "Something went wrong. Try again";
      const phoneRejectedMessage =
        language === "da"
          ? "Telefonnummeret kunne ikke genkendes. Tjek nummeret og prøv igen"
          : "The phone number could not be recognised. Check the number and try again";

      const leadAccepted = await axios
        .post(`${testLeadData?.D?.system_domain}/${POST_TESTLEAD}`, payload, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          const status = String(response?.data?.status);
          if (status === LEAD_PHONE_REJECTED_STATUS) {
            setErrorMsg(phoneRejectedMessage);
            return false;
          }
          if (status !== LEAD_ACCEPTED_STATUS) {
            setErrorMsg(failureMessage);
            return false;
          }
          setSubmitted(true);
          setPersonName([]);
          setNationName([]);
          setDescribeName([])
          reset();
          setChecked(false);
          setChecked2(false)
          return true;
        })
        .catch(() => {
          setErrorMsg(failureMessage);
          return false;
        })
        .finally(() => {
          testLeadData.mutate();
        });

      if (!leadAccepted) return;

      const emailArr = ["boligudlejning@cej.dk", "maegler@travbyen.dk"] 
      // const emailArr = ["frederikke@estatetool.dk", "frederikkewindig@gmail.com"]
        // const emailArr = ["akhil.eusteam@gmail.com", "anmol.eusteam@gmail.com"] 

      const emailPayload =  {
        "ProjectID"    : unitPid,
        "type"         : "signup-email",
        "sales_type"   : isRent ? saleType[language]["rent"]                   : saleType[language]["sales"],
        "eido_name"    : sitename,
        "unit_address" : unitAddress,
        "unit_id"      : unitId,
        "lejligheds_nr": aptNo,
        "unit_url"     : `${window.location.origin}/${language}/unit/${unitId}`,
        "eido_url"     : window.location.origin,
        "to_email"     : isRent ? emailArr[0]                                  : emailArr[1],
        "form-fields"  : {
              "first_name": data.firstname,
              "last_name" : data.lastname,
              "email"     : data.email,
              "comment"   : data.kommentar,
              "phone_number": `${data?.country_id?.country_code} ${data.phone}`,
          }
      }
     
        // console.log(emailPayload)
      const emailResponse = await axios_live.post(EMAIL(language), emailPayload);

      const variant = emailResponse.data.hasOwnProperty("recipient_email") ? 1 : 0;

  };

  const onSubmit = async (data) => {
    setErrorMsg("");
    await handleFormSubmit(data);
  };

    // select dropdown configs
  
  const ITEM_HEIGHT      = 48;
  const ITEM_PADDING_TOP = 8;


  const MenuProps = {
    anchorOrigin: {
      vertical  : "bottom",
      horizontal: !grid ? "right": "left"  // Don't pass grid from contact drawer as this condition won't work
    },
    transformOrigin: {
      vertical  : "top",
      horizontal: !grid ? "right": "left"
    },
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP,
          // width: dropdown_width
      },
    },
  };




    // handling the field which should have only number allowed
  const handleNumberInput = (event) => {
    return (event.key.charCodeAt() >= 48 && event.key.charCodeAt() <= 57) || event.key === 'Backspace' ? event.key : event.preventDefault();
  }

  return (
    <>
      {submitted ? (
          <motion.div
          initial    = {{ opacity: 0, scale: 0.5 }}
          animate    = {{ opacity: 1, scale: 1 }}
          transition = {{ duration: 0.5 }}
        >
             <SuccessMessage label = {true} labelName = {"Signupmessage"} msg = { buttonsLabel?.filter( btn => btn.UILabelProperty === 'leadSuccessMsg')[0]?.Label } />
        </motion.div>
     
      ) : (
        <>
          <Box
            sx={{
              position: 'relative',
              color   : clr.sub_text_color,
            }}
          >
            {children}
            
            <form onSubmit = {handleSubmit(onSubmit)} style = {{ background: '#ffffffe6', borderRadius: '16px', padding: '16px' }}>
              <Grid
                container
                columnSpacing = {3}
                rowSpacing    = {grid ? 2 : 1}
                sx            = {{ mb: 3 }}
              >
                
                <Grid item xs = {12}>
                <Grid sx      = {{ gap: "16px" }}>
                  <FormControl
                    sx = {{ mb: 2, gap: '8px' }}
                    fullWidth
                    variant = 'filled'
                  >
                    <CustomLabel shrink  className = "h5">
                      {buttonsLabel?.filter( btn => btn.UILabelProperty === 'FullName')[0]?.Label}&nbsp;<span>*</span>
                    </CustomLabel>
                      <TextField
                      name        = "firstname"
                      label       = {buttonsLabel?.filter(btn => btn.UILabelProperty === 'Formularfornavn')[0]?.Label || 'Fornavn'}
                      placeholder = "Fornavn"
                      required
                      control    = {control}
                      errors     = {errors}
                      helperText = {buttonsLabel?.filter( btn => btn.UILabelProperty === 'firstNameErrorWarn')[0]?.Label}
                    />
                  </FormControl>
                  <FormControl sx = {{ mb: 3 }} fullWidth variant = 'filled'>
                    <TextField
                      name        = "lastname"
                      label       = {buttonsLabel?.filter(btn => btn.UILabelProperty === 'FormularEfternavn')[0]?.Label || 'Efternavn'}
                      placeholder = "Efternavn"
                      required
                      control    = {control}
                      errors     = {errors}
                      helperText = {buttonsLabel?.filter( btn => btn.UILabelProperty === 'lastNameErrorWarn')[0]?.Label}
                    />
                  </FormControl>
                </Grid>
                </Grid>
                <Grid item xs = {12} sx = {{ pt: "0 !important" }}>
                <Grid sx      = {{ pt: "0 !important" }}>
                  <FormControl
                    sx = {{ mb: '24px', gap: '8px' }}
                    fullWidth
                    variant = 'filled'
                  >
                    <CustomLabel shrink  className = "h5">
                    {buttonsLabel?.filter( btn => btn.UILabelProperty === 'PrivateEmail')[0]?.Label}&nbsp;<span>*</span>
                    </CustomLabel>
                      <EmailField
                        name        = "email"
                        label       = {buttonsLabel?.filter(btn => btn.UILabelProperty === 'FormularEmail')[0]?.Label || 'Email'}
                        placeholder = "Email"
                        helperText  = {buttonsLabel?.filter( btn => btn.UILabelProperty === 'emailAddressErrorWarn')[0]?.Label}
                        required
                        control = {control}
                        errors  = {errors}
                      />
                  </FormControl>
                </Grid>
                </Grid>
                   <Grid item xs = {12} sx = {{ pt: "0 !important" }}>
                   <Grid sx      = {{ gap: "16px" }}>
                      <FormControl
                        sx = {{ mb: 3, gap: '8px' }}
                        fullWidth
                        variant = 'filled'
                      >
                        <CustomLabel shrink  className = "h5">
                        {buttonsLabel?.filter( btn => btn.UILabelProperty === 'PhoneNumber')[0]?.Label || "Telefon nr."}&nbsp;<span>*</span>
                        </CustomLabel>
                        <PhoneNumberDropdown error = {errors.country_id || errors.phone ? true : false} helperText = {buttonsLabel?.filter( btn => btn.UILabelProperty === 'dropdownErrorWarn')[0]?.Label || "Indtast venligst et gyldigt telefonnummer"} options = {testLeadData?.D?.countries} control = {control} getPhoneId = {'country_id'} getPhoneNumber = {'phone'} placeholder = { buttonsLabel?.filter( btn => btn.UILabelProperty === 'Country')[0]?.Label || 'Land' } description = {buttonsLabel?.filter( btn => btn.UILabelProperty === 'CountryCodeDropdownDescription')[0]?.Label || "Søg landekode"} />
                      </FormControl>
                    </Grid>
                    </Grid>
               <Grid        item xs   = {12} sx                            = {{ pt: "0 !important" }}>
               <FormControl sx        = {{ mb: '24px' }} fullWidth variant = 'filled'>
               <CustomLabel className = "h5" shrink isDesktop              = {isDesktop}>{ buttonsLabel?.filter( btn => btn.UILabelProperty === 'FormularKommentar')[0]?.Label }</CustomLabel>
                    <CustomInput
                      placeholder = { buttonsLabel?.filter( btn => btn.UILabelProperty === 'commentPlaceholder')[0]?.Label }
                      multiline
                      rows = {4}
                      {...register('kommentar')}
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Box         sx                  = {{ mb: 3, display: "flex", flexDirection: "column", gap: "8px" }}>
              <CustomLabel fullWidth className = "h4" >
                  {/* { buttonsLabel?.filter( btn => btn.UILabelProperty === 'FormularBetingelser')[0]?.Label }&nbsp;<span>*</span> */}
                  Betingelser/OPLYSNING OM BEHANDLING AF PERSONOPLYSNINGER * 
                </CustomLabel>
                <Box sx = {{ display: "flex", flexDirection: "column", gap: "16px" ,color:"#004337"}}>
                  {
                    isRent ?
                      <FormControlLabel
                        sx={{
                          alignItems: 'center',
                          mr        : 0,
                          ml        : 0,
                          gap       : '8px',
                          "span"    : {    color: '#000' },
                          "a"       : {color: `${'#000'} !important` },
                        }}
                        control={
                          <CheckBox
                            name     = '_value'
                            checked  = {checked}
                            onChange = {handleCheckbox}
                            sx       = {{ p: 0 }}
                          />
                        }
                        label={
                          <Box >
                            <div>
                              <span className = "paragraph2-light">{language === "en" ? "I agree to be contacted by Travbyen's partner, CEJ, to whom we will pass on your contact information, in order to facilitate future contact, and I am aware of" : "Jeg accepterer at blive kontaktet af Travbyens samarbejdspartner, CEJ, som vi videregiver dine kontaktoplysninger til, med henblik på at formidle den fremadrettede kontakt, og jeg er bekendt med"} <a className = "h5" style = {{ textDecoration: 'none', whiteSpace: "nowrap" }} href = {"https://travbyen.dk/privatlivspolitik/"} target = "_blank">{ language === "en" ? "the privacy policy" : "privatlivspolitikken"}</a> { language === "en" ? "regarding KIRKBI Invest A/S' processing of my personal data.": "vedrørende KIRKBI Invest A/S' behandling af mine personoplysninger."}&nbsp;</span>
                            </div>
                          </Box>
                        }
                      />
                : 
                <>
                  <FormControlLabel
                  sx={{
                    alignItems: 'center',
                    mr        : 0,
                    ml        : 0,
                    gap       : '8px',
                    "span"    : {    color: '#000' },
                    "a"       : {color: `${'#000'} !important` },
                  }}
                  control={
                    <CheckBox
                      name     = '_value'
                      checked  = {checked}
                      onChange = {handleCheckbox}
                      sx       = {{ p: 0 }}
                    />
                  }
                  label={
                    <Box sx = {{color:clr?.primary_text}}>
                      <div>
                         <span className = "paragraph2-light">{language === "en" ? "I agree to be contacted by Travbyen's partners (Estate, Home and Nybolig), to whom we pass on your contact information, in order to communicate the future contact, and I am familiar with" : "Jeg accepterer at blive kontaktet af Travbyens samarbejdspartnere (Estate, Home og Nybolig), som vi videregiver dine kontaktoplysninger til, med henblik på at formidle den fremadrettede kontakt, og jeg er bekendt med"} <a className = "h5" style = {{ textDecoration: 'none' }} href = {"https://travbyen.dk/privatlivspolitik/"} target = "_blank">{ language === "en" ? "the privacy policy" : "privatlivspolitikken"}</a> { language === "en" ? "KIRKBI Invest A/S' processing of my personal data.": "KIRKBI Invest A/S' behandling af mine personoplysninger."}&nbsp;</span>
                      </div>
                    </Box>
                  }
                />
                </>
                  }
          
                  
                  {/* <FormControlLabel
                  sx={{
                    alignItems: 'flex-start',
                    mr        : 0,
                    ml        : 0,
                    gap       : '8px',
                    "span"    : { color: clr?.alternative_condition },
                    "a"       : {color: `${clr?.alternative_condition} !important` },
                  }}
                  control={
                    <CheckBox
                      name     = '_value'
                      checked  = {checked}
                      onChange = {handleCheckbox}
                      sx       = {{ p: 0 }}
                    />
                  }
                  label={
                    <Box >
                      <div dangerouslySetInnerHTML = {{ __html: buttonsLabel?.filter( btn => btn.UILabelProperty === 'FormularBetingelserTekst')[0]?.Label }}>
                      </div>
                    </Box>
                  }
                /> */}
                
                </Box>
              </Box>
              <Box
                sx={{
                  position: { xs: atUnit ? 'unset' :"fixed", sm: "unset" },
                  bottom  : 0,
                  left    : 0,
                  width   : "100%",
                  zIndex  : '5',
                  "button": {
                    width  : { xs: atUnit ? 'auto' : "100%", sm: "fit-content" },
                    height : { xs: !atUnit ? "60px" : "44px" , sm: "44px"},
                    padding: { xs: !atUnit ? "12px 40px 30px 40px" : "12px 40px" }
                  }
                }}
              >
                 <CustomButton
                type      = 'submit'
                className = "eus-button-2"
                clr       = {clr}
                disabled  = { !checked || !isValid || isSubmitting }
                variant   = "primary"
                padding   = {"12px 24px"}
              > 
              {
                isSubmitting ? <CircularProgress size={18} color="inherit" /> : language === "da" ? "Indsend" : "Submit"
              }
                {/* { buttonsLabel?.filter( btn => btn.UILabelProperty === 'SignUp' )[0]?.Label } */}
              </CustomButton>
              </Box>
              {errorMsg && (
                <Box role="alert" sx={{ color: "error.main", mt: "8px" }}>
                  {errorMsg}
                </Box>
              )}
            </form>
          </Box>
        </>
      )}
    </>
  )
};

ContactForm.propTypes = {
  children: PropTypes.node,
  grid    : PropTypes.bool,
  unit    : PropTypes.instanceOf(Unit),
};

export default ContactForm;
